export enum FrageKognitivesHilfsmittel {
  BRILLE = 'brille',

  HOERGERAET = 'hoergeraet',
}
